// extracted by mini-css-extract-plugin
export default {"control":"CSSlideButton_control__hJoXm","viewport":"CSSlideButton_viewport__BsKgU"};